import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none",
  viewBox: "0 0 25 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#151515",
  d: "M13.272 2.428a3 3 0 0 1 4.34 1.097l2.274 4.358h.408l.226.012a2.205 2.205 0 0 1 1.979 2.193v9.707l-.012.225a2.206 2.206 0 0 1-1.967 1.97l-.226.01H4.704A2.206 2.206 0 0 1 2.5 19.795v-9.707c0-1.218.987-2.205 2.205-2.205h.599l-.03-.044zM4.704 19.795h15.59v-9.707H4.704zM15.84 4.45a1 1 0 0 0-1.447-.365L8.777 7.883h8.853z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FF760A",
  "fill-rule": "evenodd",
  d: "M5.945 17.294a1 1 0 0 1 1-1h5.556a1 1 0 0 1 0 2H6.945a1 1 0 0 1-1-1",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }